export const NANOID_LENGTH = 10;
export const UUID_LENGTH = 36;
